import resolveDeviceName from "src/modules/device/resolveDeviceName";
import environment, { getEnvironmentVariable } from "src/utils/environment";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

const ElectronSentry = window.require("@sentry/electron");
const { isDev, storyMode, isBrowser, appName } = environment;

if (storyMode === false && !isBrowser) {
  ElectronSentry.init({
    dsn: getEnvironmentVariable("CRASH_REPORTER_URL"),
    debug: isDev,
    environment: getEnvironmentVariable("ENVIRONMENT")
  });

  ElectronSentry.configureScope((scope) => {
    scope.setExtra("deviceName", resolveDeviceName());
  });
}

if (storyMode === false && isBrowser) {
  Sentry.init({
    dsn: getEnvironmentVariable("BROWSER_CRASH_REPORTER_URL"),
    integrations: [new BrowserTracing()],
    environment: getEnvironmentVariable("ENVIRONMENT"),
    tracesSampleRate: 0
  });
  Sentry.setTag("app", appName);
}
